import { render, staticRenderFns } from "./TopCategory.vue?vue&type=template&id=51fba015&"
import script from "./TopCategory.js?vue&type=script&lang=js&"
export * from "./TopCategory.js?vue&type=script&lang=js&"
import style0 from "./TopCategory.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports